// extracted by mini-css-extract-plugin
export default {"container":"Mr-z","brandName":"Nr-z","productName":"Or-z","productNamePdpEnhancements":"Pr-z","breakLongProductName":"Qr-z"};